import React, { lazy, useState } from "react";
import { Tabs } from "antd";
import { isMobile } from "@/utils/public";
import ZntSj from "./zntsj";
import Home from "./home";

function ZdSearchContent(props) {
  const { onClick ,categoryId} = props;
  const isMob = isMobile();
  const [tab, setTab] = useState("home");
  const tabs = [
    {
      label: "首页",
      key: "home",
    },
    {
      label: "智能体上架",
      key: "zntsj",
    },
  ];
  return (
    <div className="zdSearch">
      <div className="mxgcHeader">
        <div
          className="title"
          style={{
            padding: isMob ? "0 24px 0 28px" : "0 35px",
          }}
        >
          {isMob ? "" : "智能体广场"}
        </div>
        <div
          className="tabs"
          style={{
            paddingRight: isMob ? "unset" : "40px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            {tabs.map((item) => {
              return (
                <div
                  className="tabItem"
                  style={{
                    borderBottom:
                      tab === item.key ? "3px solid #1E5BCE" : "unset",
                    color: tab === item.key ? "#1E5BCE" : "unset",
                    cursor: "pointer",
                    padding: isMob ? "0 6px" : "0 10px",
                  }}
                  onClick={() => {
                    setTab(item.key);
                  }}
                >
                  {item.label}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {tab === "home" ? <Home onClick={onClick} categoryId={categoryId}  /> : undefined}
      {tab === "zntsj" ? <ZntSj /> : undefined}
    </div>
  );
}

export default ZdSearchContent;
